export default __webpack_public_path__ + "static/media/visa-img.4d49a0f9.png";